import type SubjectFieldDraftView from '@UI/Store/SubjectTypeDefinitions/Views/SubjectFieldDraftView';

/** The fields of the sheet, archived ones excluded: they no longer appear on a dossier. */
const describeFieldCount = (fields: readonly SubjectFieldDraftView[]): string => {
	const count = fields.filter((field) => !field.archived).length;

	if (count === 0) {
		return 'Aucun champ';
	}

	return count === 1 ? '1 champ' : `${count} champs`;
};

export default describeFieldCount;
